<template>
  <div>
    <Layout/>
    <h4>Diagnósticos</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idAtencion" class="form-label">IdAtencion</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idAtencion" name="idAtencion" v-model="datoAtencion.idAtencion" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idPersona" name="idPersona" v-model="datoAtencion.idPersona"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idPersona" class="form-label"> Persona</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="persona" name="persona" v-model="datoAtencion.persona" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalPersonaLOV"
                      title="Buscar Personas">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idMedico" name="idMedico" v-model="datoAtencion.idMedico"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idMedico" class="form-label"> Medico</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="medico" name="medico" v-model="datoAtencion.medico" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalMedicoLOV"
                      title="Buscar Médico">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idCita" name="idCita" v-model="datoAtencion.idCita"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idCita" class="form-label"> Cita</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="cita" name="cita" v-model="datoAtencion.cita" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalCitaLOV"
                      title="Buscar Citas">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Observación</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="observacion" name="observacion" v-model="datoAtencion.observacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoAtencion.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaAct" class="form-label">FechaAct</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaAct" name="fechaAct" v-model="datoAtencion.fechaAct" required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" @click.prevent="cerrarAtencion" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarAtencion" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditAtencion" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdAnatAten</th>
          <th scope="col">IdAnatomia</th>
          <th scope="col">IdAtencion</th>
          <th scope="col">Observación</th>
          <th scope="col">Estado</th>
          <th scope="col">AtencionFechaReg</th>
          <th scope="col">AnatomiaNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="anataten in datosPaginados" :key="anataten.idAnatAten">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(anataten.idAnatAten)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(anataten.idAnatAten)" title="Editar">edit_square</i></td>
          <td>{{anataten.idAnatAten}}</td>
          <td>{{anataten.idAnatomia}}</td>
          <td>{{anataten.idAtencion}}</td>
          <td>{{anataten.observacion}}</td>
          <td>{{anataten.estado}}</td>
          <td>{{getFormattedDate(anataten.atencionFechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{anataten.anatomiaNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteAtencion(anataten.idAnatAten)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idAnatAten" class="form-label">IdAnatAten</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idAnatAten" name="idAnatAten" v-model="datoAnatAten.idAnatAten" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idAnatomia" name="idAnatomia" v-model="datoAnatAten.idAnatomia"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idAnatomia" class="form-label"> Anatomia</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="anatomia" name="anatomia" v-model="datoAnatAten.anatomia" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalAnatomiaLOV"
                      title="Buscar Anatomía">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idAtencion" class="form-label">IdAtencion</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idAtencion" name="idAtencion" v-model="datoAnatAten.idAtencion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Observación</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="observacion" name="observacion" v-model="datoAnatAten.observacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarAnatAten" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditAnatAten" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

<!--
Listas de valores master
-->
<!-- Lista de Valores: Persona -->
    <PersonaLOV @DatosPersona="GetDataPersonaLOV($event)"/>
<!-- Lista de Valores: Medico -->
    <MedicoLOV @DatosMedico="GetDataMedicoLOV($event)"/>
<!-- Lista de Valores: Cita -->
    <CitaLOV @DatosCita="GetDataCitaLOV($event)"/>
<!--
Listas de valores master
-->
<!--
Listas de valores details
-->
<!-- Lista de Valores: AnatAten -->
    <AnatAtenLOVdet @DatosAnatAten="GetDataAnatAtenLOVdet($event)"/>
<!-- Lista de Valores: Anatomia -->
    <AnatomiaLOVdet @DatosAnatomia="GetDataAnatomiaLOVdet($event)"/>
<!--
Listas de valores details
-->
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import dateFormat from '@/modules/dateFormat.js';
// Listas de valores master
import PersonaLOV from '../../components/lovs/PersonaLOV.vue'
import MedicoLOV from '../../components/lovs/MedicoLOV.vue'
import CitaLOV from '../../components/lovs/CitaLOV.vue'
// Listas de valores master
// Listas de valores details
import AnatAtenLOVdet from '../../components/lovs/AnatAtenLOV.vue'
import AnatomiaLOVdet from '../../components/lovs/AnatomiaLOV.vue'
// Listas de valores details
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
// Listas de valores master
, PersonaLOV
, MedicoLOV
, CitaLOV
// Listas de valores master
// Listas de valores details
, AnatAtenLOVdet
, AnatomiaLOVdet
// Listas de valores details
  },
  data () {
    return {
// Variables master
      atencions : [],
      datoAtencion : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idAtencion: '',
// Variables master
// Variables details
      anatatens : [],
      datoAnatAten : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idAtencion = this.$route.params.p_idatencion
    this.abrirEditar(this.p_idAtencion)
    this.getAnatAtens()
    this.getDataPagina(this.paginaActual)
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
// Procedimientos master
    validarForm(){
      if(this.datoAtencion.idAtencion === ''){
        swal("Error!", "El elemento idAtencion no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAtencion.idPersona === ''){
        swal("Error!", "El elemento idPersona no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAtencion.idMedico === ''){
        swal("Error!", "El elemento idMedico no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAtencion.idCita === ''){
        swal("Error!", "El elemento idCita no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAtencion.observacion === ''){
        swal("Error!", "El elemento observacion no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAtencion.fechaReg === ''){
        swal("Error!", "El elemento fechaReg no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAtencion.fechaAct === ''){
        swal("Error!", "El elemento fechaAct no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAtencion.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarAtencion(){
      if(this.validarForm() === 1){
        try {
          await api.post('/atencions', this.datoAtencion)
          swal("Correcto!", "Atencion creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditAtencion(){
      if(this.validarForm() === 1){
        try {
          await api.post('/atencions', this.datoAtencion)
          swal("Correcto!", "Atencion creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoAtencion={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idAtencion){
      this.modalWindow = true
      if(idAtencion != null){    
           api.get('/vwatencions/'+idAtencion).then(resp=>{
          this.datoAtencion = resp.data;
           });
      }
      this.titulo   = 'Editar Diagnósticos'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarAtencion(){
      this.$router.push('/Atencion')
    },
// Procedimientos master
// Procedimientos detalle
    async getAnatAtens() {
      const resp = await api.get('/anatatens')
      this.anatatens = resp.data
    },
    totalPaginas(){
      return Math.ceil(this.anatatens.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwanatatens/nombre/'+this.nombreBusqueda).then(response=>{
          this.anatatens=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.anatatens.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwanatatens').then(response=>{
      this.anatatens=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.anatatens.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      if(this.datoAnatAten.idAtencion === ''){
        swal("Error!", "El elemento idAtencion no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAnatAten.idPersona === ''){
        swal("Error!", "El elemento idPersona no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAnatAten.idMedico === ''){
        swal("Error!", "El elemento idMedico no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAnatAten.idCita === ''){
        swal("Error!", "El elemento idCita no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAnatAten.observacion === ''){
        swal("Error!", "El elemento observacion no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAnatAten.fechaReg === ''){
        swal("Error!", "El elemento fechaReg no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAnatAten.fechaAct === ''){
        swal("Error!", "El elemento fechaAct no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAnatAten.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarAnatAten(){
      if(this.validarForm() === 1){
        try {
          this.datoAnatAten.idAtencion = this.datoAtencion.idAtencion;
          await api.post('/anatatens', this.datoAnatAten)
          this.getAnatAtens();
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "AnatAten creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditAnatAten(){
      if(this.validarForm() === 1){
        try {
          await api.post('/anatatens', this.datoAnatAten)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "AnatAten creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoAnatAten={}
      this.titulo   = 'Crear Diagnósticos'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idAnatAten){
      this.modalWindow = true
      if(idAnatAten != null){    
           api.get('/vwanatatens/'+idAnatAten).then(resp=>{
          this.datoAnatAten = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Diagnósticos'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idAnatAten){
      this.modalWindow = true
      if(idAnatAten != null){
        this.$router.push('/anatatenmd/'+idAnatAten)
      }
    },
    async deleteAnatAten (idAnatAten) {
      try{
        await api.delete('/anatatens/'+idAnatAten)
          this.getAnatAtens()
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
// Listas de valores master
//    Lista de Valores
    GetDataPersonaLOV(data) {
      this.datoAtencion.idPersona = data.idPersona;
      this.datoAtencion.persona = data.nombre;
    },
//    Lista de Valores
    GetDataMedicoLOV(data) {
      this.datoAtencion.idMedico = data.idMedico;
      this.datoAtencion.medico = data.nombre;
    },
//    Lista de Valores
    GetDataCitaLOV(data) {
      this.datoAtencion.idCita = data.idCita;
      this.datoAtencion.cita = data.nombre;
    },
// Listas de valores master
// Listas de valores details
//    Lista de Valores
    GetDataAnatAtenLOVdet(data) {
      this.datoAnatAten.idAnatAten = data.idAnatAten;
      this.datoAnatAten.anatAten = data.nombre;
    },
//    Lista de Valores
    GetDataAnatomiaLOVdet(data) {
      this.datoAnatAten.idAnatomia = data.idAnatomia;
      this.datoAnatAten.anatomia = data.nombre;
    },
// Listas de valores details
  },
}
</script>
